module.exports = __webpack_public_path__ + "static/img/top_spread.6c91166.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/top_spread.png
// module id = BHX7
// module chunks = 1